import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import Checkbox from "components/DesignComponents/Checkbox";
import Slider from "components/DesignComponents/Slider";
import { TRACK_TYPE } from "components/DesignComponents/Slider/types";
import { body2SemiBold } from "shared/styles/typography";

import { useMarks } from "./hooks";
import { ScheduleTimeProps } from "./types";

const ScheduleTime = ({
    isLoading,
    isInverted,
    value,
    fromDate,
    toDate,
    toggleInvertion,
    handleChange
}: ScheduleTimeProps) => {
    const { t } = useTranslation();
    const { marks } = useMarks();

    return (
        <>
            <Slider
                label={t("Dialog##select time interval")}
                value={value}
                onChange={(_, newValue) => handleChange(newValue as number[])}
                track={isInverted ? TRACK_TYPE.Inverted : TRACK_TYPE.Normal}
                marks={marks}
                min={0}
                max={48}
                disabled={isLoading}
            />

            <div css={[body2SemiBold, { marginTop: "16px" }]}>
                {t("Dialog##selected time window", { fromDate, toDate })}
            </div>

            <Checkbox
                label={t("Dialog##inverted selection")}
                onChange={toggleInvertion}
                checked={isInverted}
                disabled={isLoading}
                customStyle={{ marginTop: "16px" }}
            />

            <BannerView
                bannerType={BannerType.Info}
                title={t("Dialog##scheduled time warning")}
                css={css({
                    margin: "16px 0"
                })}
            />
        </>
    );
};

export default ScheduleTime;
